import { ByteArray } from "../ByteArray"
import { ICommand } from "./ICommand"

export class CMDBlackjackCountDown implements ICommand
{

	public KickNoBetPlayerCountDown : number = 0;
	public InsuranceCountDown : number = 0;
	public DecisionCountDown : number = 0;
	public FollowDecisionCountDown : number = 0;

	public constructor()
	{
	}

	public fromBytes(ba : ByteArray) : void
	{
		this.KickNoBetPlayerCountDown = ba.readUint32();
		this.InsuranceCountDown = ba.readUint32();
		this.DecisionCountDown = ba.readUint32();
		this.FollowDecisionCountDown = ba.readUint32();
	}

	public toBytes() : ByteArray
	{
		let ba: ByteArray = new ByteArray();

		ba.writeUint32(this.KickNoBetPlayerCountDown);
		ba.writeUint32(this.InsuranceCountDown);
		ba.writeUint32(this.DecisionCountDown);
		ba.writeUint32(this.FollowDecisionCountDown);

		return ba;
	}

	public clone() : ICommand
	{
		let cmd : ICommand = new CMDBlackjackCountDown();
		cmd.fromBytes(this.toBytes());

		return cmd;
	}

	public toString() : string
	{
		let str:string = '';
		str += 'KickNoBetPlayerCountDown(D)='+this.KickNoBetPlayerCountDown+' ';
		str += 'InsuranceCountDown(D)='+this.InsuranceCountDown+' ';
		str += 'DecisionCountDown(D)='+this.DecisionCountDown+' ';
		str += 'FollowDecisionCountDown(D)='+this.FollowDecisionCountDown+' ';
		return str;
	}

	public getCmdID() : number
	{
		return 0;
	}

	public getCmdName() : string
	{
		return 'BlackjackCountDown';
	}

}
